const VERSION = `2026.10.8`

export const appVersion = () => {
  return VERSION
}
